import type { GiftCardIssueCounts } from '@common/api/graphql/getIssueCountsGql';
import type { AppAction } from '../actions/actionType';
import { AppActionTypes } from '../actions/actionType';

const giftCardIssueCounts = (
  state: GiftCardIssueCounts = [],
  action: AppAction
): GiftCardIssueCounts => {
  switch (action.type) {
    case AppActionTypes.GET_ISSUE_COUNTS_SUCCESS:
      return action.issueCountResult.giftCardResults;
    default:
      return state;
  }
};

export default giftCardIssueCounts;
